import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Content, Button, Label } from './vehicle-class.styled';

import { CustomSelect } from '../custom-select/custom-select';

export const VehicleClass = (props) => {
  const { t } = useTranslation();
  const { value, change, loading, title, disabled, id } = props;
  const [classInCO, setClassInCO] = useState(value);

  useEffect(() => {
    setClassInCO(value);
  }, [value, id]);

  /**
   * change option
   */
  const onChange = () => {
    if (!classInCO || disabled) return;

    change(classInCO);
  };

  const handleValueChange = (val) => {
    setClassInCO(val);
  };

  const cl = loading ? 'loading' : '';
  const titleOk = title ?? t('windows.Класс ТС');

  const itemsSelect = [
    { id: 1, value: 1, name: t('vehicleClass.Легковые автомобили') },
    { id: 2, value: 2, name: t('vehicleClass.Микроавтобусы / газели') },
    { id: 3, value: 3, name: t('vehicleClass.Грузовики / автобусы') },
    { id: 4, value: 4, name: t('vehicleClass.Спецтранспорт (с прицепом)') },
  ];

  return (
    <Content className={cl}>
      <Label>{titleOk}&nbsp;:</Label>
      <CustomSelect className="vehicle-class" value={classInCO} onChange={handleValueChange} items={itemsSelect} disabled={disabled} />

      <Button type="button" onClick={onChange} style={{ visibility: disabled ? 'hidden' : 'inherit' }}>
        {t('buttons.Установить')}
      </Button>
    </Content>
  );
};
